import React from "react";
import { Link } from "react-router-dom";

const BreadcrumbItem = ({ to, children, isLast = false }) => {
  return to && !isLast ? (
    <Link to={to} className="breadcrumb-link">
      {children}
    </Link>
  ) : (
    <span className="breadcrumb-current">{children}</span>
  );
};

export default BreadcrumbItem;
